import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CriptoService {

  private readonly algorithm = 'AES-GCM';
  private readonly keyLength = 256;

  constructor() { }

  private async getKey(password: string): Promise<CryptoKey>{
    const encoder = new TextEncoder();
    const passBuffer = encoder.encode(password);

    const importedKey = await crypto.subtle.importKey(
      'raw',
      passBuffer,
      'PBKDF2',
      false,
      ['deriveKey']
    );

    return crypto.subtle.deriveKey(
      {
        name: 'PBKDF2',
        salt: encoder.encode('static-salt'), // Usar un salt único en producción
        iterations: 100000,
        hash: 'SHA-256'
      },
      importedKey,
      { name: this.algorithm, length: this.keyLength },
      false,
      ['encrypt', 'decrypt']
    );
  }

  public async encrypt(data: any, password: string){
    try{
      const key = await this.getKey(password);
      const iv = crypto.getRandomValues(new Uint8Array(12));

      const encodeData = new TextEncoder().encode(data);

      const encrypted = await crypto.subtle.encrypt(
        { name: this.algorithm, iv},
        key,
        encodeData
      );

      const combined = new Uint8Array(iv.length + encrypted.byteLength);
      combined.set(iv);
      combined.set(new Uint8Array(encrypted), iv.length);

      return btoa(String.fromCharCode(... combined));
    }catch(err){
      throw err;
    }
  }

  public async decrypt(encryptedData: string, password: string): Promise<string> {
    try {
      const key = await this.getKey(password);
      const combined = Uint8Array.from(atob(encryptedData), c => c.charCodeAt(0));
      
      const iv = combined.slice(0, 12);
      const data = combined.slice(12);

      const decrypted = await crypto.subtle.decrypt(
        { name: this.algorithm, iv },
        key,
        data
      );

      return new TextDecoder().decode(decrypted);
    } catch (err) {
      throw err;
    }
  }
}
